import React from 'react';
import styled from 'styled-components';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';

const SectionWrapper = styled.section`
  padding: 80px 5%;
  background: #fdfdfd;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 38px;
  font-weight: 800;
  color: #1a202c; /* Tighter contrast */
  margin-bottom: 15px;
`;

const Subtitle = styled.p`
  font-family: 'Open Sans', sans-serif;
  color: #718096;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: 500;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #ffffff;
  border-top: 4px solid #25aae3;
  border-radius: 8px; /* Softer radius */
  padding: 40px 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.06); /* Better shadows */
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0,0,0,0.1);
  }
`;

const IconWrapper = styled.div`
  color: #4a5568;
  margin-bottom: 20px;
  transition: color 0.3s ease;
  
  svg {
    font-size: 40px; /* Slightly bigger */
  }

  ${Card}:hover & {
    color: #25aae3; /* Color pop on hover */
  }
`;

const CardTitle = styled.h3`
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #2b3e51;
  margin-bottom: 15px;
`;

const CardText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #718096; /* Contrast improvement */
  line-height: 1.6;
`;

const Capabilities = () => {
  const items = [
    {
      icon: <CheckBoxOutlinedIcon />,
      title: 'Post from Desktop',
      text: 'Easily post photos, videos, stories, and carousels to your Instagram account from our web app.'
    },
    {
      icon: <DateRangeOutlinedIcon />,
      title: 'Scheduled Posts',
      text: 'Use our post scheduler to create a calendar for several posts for future dates, saving you time and energy.'
    },
    {
      icon: <ForumOutlinedIcon />,
      title: 'Automated Interactions',
      text: 'Gain exposure by automatically interacting using your choice of: likes, comments, follows, and unfollows.'
    },
    {
      icon: <AutorenewOutlinedIcon />,
      title: 'Repost Media',
      text: 'Take the pressure of posting daily away by automatically reposting media from other similar users.'
    },
    {
      icon: <MyLocationOutlinedIcon />,
      title: 'Powerful Targeting',
      text: 'Specify your target audience through hashtags, locations, and usernames in order to interact with the right users.'
    },
    {
      icon: <InsertChartOutlinedIcon />,
      title: 'Analyze Progress',
      text: 'View the amount of interactions your accounts have done each day using the data graphs in your dashboard'
    }
  ];

  return (
    <SectionWrapper id="capabilities">
      <Container>
        <Title>Extensive List of Capabilities</Title>
        <Subtitle>Use a few of our extensive tools, or use them all, it's up to you!</Subtitle>
        <Grid>
          {items.map((item, idx) => (
            <Card key={idx}>
              <IconWrapper>{item.icon}</IconWrapper>
              <CardTitle>{item.title}</CardTitle>
              <CardText>{item.text}</CardText>
            </Card>
          ))}
        </Grid>
      </Container>
    </SectionWrapper>
  );
};

export default Capabilities;
